<template>
  <footer>
    <div class="container">
      <div class="row">
        <div class="col-sm-8 offset-sm-2 offset-lg-0 col-lg-6 col-lg-6 order-lg-4">
          <form method="POST" v-on:submit.prevent="subscribe">
            <div class="input-group" v-bind:class="{'has-danger': hasError('email')}">
              <input type="email" class="form-control" placeholder="Add meg az e-mail címed!" ref="newsLetterMail" v-model="email">
              <div class="input-group-append">
                <button class="btn btn-outline" @click="subscribe" type="button">Feliratkozás</button>
              </div>
              <div class="form-control-feedback">
                <span v-for="message in filter('email')" v-bind:key="message">
                    {{message}} <br/>
                </span>
              </div>
            </div>
          </form>
        </div>
        <div class="col-lg-3 order-lg-10 order-lg-10 social">
          <a href="https://www.facebook.com/konyvmogul.hu/" target="_blank"><i class="fab fa-facebook-f"></i></a>
          <a href="https://www.pinterest.com/konyvmogul/" target="_blank"><i class="fab fa-pinterest-p"></i></a>
          <a href="https://www.twitter.com/konyvmogul/" target="_blank"><i class="fab fa-twitter"></i></a>
        </div>
        <div class="col-lg-3 order-lg-1">
          <a href="/"><img src="/static/images/logo.svg" alt=""></a>
        </div>
      </div>
      <p class="fLinks">
        <a href="https://konyvmogul.hu/szallitasi-informaciok/" target="_blank">Szállítási információk</a>
        <a href="https://konyvmogul.hu/adatvedelmi-nyilatkozat/" target="_blank">Adatvédelmi nyilatkozat</a>
      </p>
    </div>
    <FrontendToaster
      :text="'Sikeres feliratkozás!'"
      :delay="4000"
      ></FrontendToaster>
  </footer>
</template>

<script>
import FrontendToaster from '../partials/toaster'

export default {
  name: 'FrontendFooter',
  components: {
    FrontendToaster
  },
  data () {
    return {
      email: null,
      errors: {}
    }
  },
  mounted: function () {
    window.$('footer .toast').on('shown.bs.toast', function () {
      window.$('footer .toastWr').addClass('show')
    })
    window.$('footer .toast').on('hidden.bs.toast', function () {
      window.$('footer .toastWr').removeClass('show')
    })
  },
  methods: {
    subscribe () {
      let self = this
      let url = process.env.API_URL + '/' + process.env.API_ENDPOINT

      this.$http
        .post(url + `/subscribe`, {email: this.email}, {
          'headers': {
            'language': self.$store.state.loading.language
          }
        }).then(res => {
          if (res.data && res.data.data !== 'undefined') {
            self.email = null
            self.errors = null
            this.$refs.newsLetterMail.blur()
            window.$('footer .toast').toast('show')
          } else {
            self.errors = res.response.data.errors
          }
        }).catch(res => {

        })
    },
    hasError (val) {
      for (let er in this.errors) {
        if (er === val) {
          return true
        }
      }

      return false
    },
    filter: function (name) {
      for (let er in this.errors) {
        if (er === name) {
          this.hasDanger = true
          return this.errors[er]
        }
      }

      this.hasDanger = false
      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frontend/partials/footer.vue